export const BASE_URL = process.env.BASE_URL || ''

console.log('BASE_URL', BASE_URL)
